// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ErrorBlock_errorText__1DW92","show":"ErrorBlock_show__ZkCOU"};